import {
    apiRequest,
    pengalamanKerjaDetail
} from "../../../../../services/adapters/kepegawaian/pengalamanKerjaService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", pengalamanKerjaDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository